import { create } from 'zustand';
import type { WebViewParams } from '@core/config/url-params';

interface NavigationState {
  urlParams: WebViewParams | null;
  resolvedItemCode: string | null;
  isResolvingItemCode: boolean;
  currentRoute: string;
  canGoBack: boolean;
  setUrlParams: (params: WebViewParams) => void;
  setResolvedItemCode: (code: string) => void;
  setIsResolvingItemCode: (resolving: boolean) => void;
  setCurrentRoute: (route: string) => void;
  setCanGoBack: (canGoBack: boolean) => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
  urlParams: null,
  resolvedItemCode: null,
  isResolvingItemCode: false,
  currentRoute: '/',
  canGoBack: false,
  setUrlParams: (params) => set({ urlParams: params }),
  setResolvedItemCode: (code) => set({ resolvedItemCode: code }),
  setIsResolvingItemCode: (resolving) => set({ isResolvingItemCode: resolving }),
  setCurrentRoute: (route) => set({ currentRoute: route }),
  setCanGoBack: (canGoBack) => set({ canGoBack }),
}));
